import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { conciergeApi, errMsg } from "@/components/concierge/api";
import { toggleDepositStep } from "@/components/concierge/depositSteps";
import { DepositHistoryList } from "@/components/concierge/DepositHistoryList";

const FILTERS = [["all", "Tous"], ["pressing", "Chez le pressing"], ["ready", "À rendre au client"], ["returned", "Rendus au client"]];

export const AllDepositsSection = () => {
  const [deposits, setDeposits] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");

  const load = useCallback(async () => {
    const res = await conciergeApi.get("/deposits");
    setDeposits(res.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggleReturned = async (d, field) => {
    try {
      await toggleDepositStep(d, field);
      load();
    } catch (error) {
      toast.error(errMsg(error));
    }
  };

  const q = search.trim().toLowerCase();
  const matchFilter = (d) => ({
    all: true,
    pressing: !d.pressing_returned_at && !d.returned_at,
    ready: d.pressing_returned_at && !d.returned_at,
    returned: !!d.returned_at,
  }[filter]);
  const visible = deposits
    .filter(matchFilter)
    .filter((d) => `${d.number} ${d.person_name} ${d.company_name || ""} ${d.tracking_number || ""}`.toLowerCase().includes(q))
    .map((d) => ({ ...d, number: `${d.number} — ${d.person_name}${d.company_name ? ` (${d.company_name})` : " (Admin)"}` }));

  return (
    <div className="space-y-3" data-testid="concierge-all-deposits">
      <div className="flex gap-2 flex-wrap">
        {FILTERS.map(([key, label]) => (
          <button key={key} onClick={() => setFilter(key)} data-testid={`history-filter-${key}`}
            className={`px-4 py-2 rounded-full text-sm font-semibold border ${filter === key ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600"}`}>{label}</button>
        ))}
      </div>
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
        <Input className="pl-9" placeholder="Rechercher (nom, entreprise, n° de bon ou de marquage)..." value={search} onChange={(e) => setSearch(e.target.value)} data-testid="history-search-input" />
      </div>
      <DepositHistoryList deposits={visible} onToggle={toggleReturned} />
    </div>
  );
};
